import { Component, TemplateRef } from "@angular/core";

import { ICellRendererParams } from '@ag-grid-community/core';
import { ICellRendererAngularComp } from '@ag-grid-community/angular';
//import { AgGridRowModel } from "./ag-grid.component";

interface AgGridRowOptionsCellRendererParams extends ICellRendererParams {
  rowCommandTemplateRef: TemplateRef<any>;
}

@Component({
  selector: 'datex-ag-grid-row-options',
  templateUrl: './ag-grid-row-options.component.html',
  standalone: false
})
export class AgGridRowOptionsCellRenderer implements ICellRendererAngularComp {
  row: any;
  rowCommandTemplateRef: TemplateRef<any>;

  agInit(params: AgGridRowOptionsCellRendererParams): void {
    this.row = params.data;
    this.rowCommandTemplateRef = params.rowCommandTemplateRef;
  }

  refresh(params: AgGridRowOptionsCellRendererParams): boolean {
    return false;
  }
}